<div class="homepage-section">
 
  <div class="choir-resources-section">
     
    <img src="assets/images/RevelBase_Home.png" alt="Revel Singers" class="choir-resources-image">

    <p>
      Choir database for Revel, a Czech choir specializing in renaissance music.<br/>
      It contains information about composers, songs (including sheet music, MIDI etc.) and revels (rehearsals and concerts).
    </p>

    <br/>
    <p><b>Choir Resources:</b></p>
    <!-- Add Choir Resource - only visible to admins -->
    <!-- Desktop toolbar: keep Add button inline; hide on handset -->
    <div *ngIf="!(isHandset$ | async)" class="toolbar-row" style="display: flex; align-items: center; gap: 20px; margin-bottom: 10px;">
      <button *ngIf="currentUserIsAdmin" mat-raised-button color="primary" (click)="addChoirResource()">Add Resource</button>
    </div>
    <!-- Handset toolbar: align with table edges (no add button shown) -->
    <div *ngIf="isHandset$ | async" class="toolbar-row" style="display: flex; flex-direction: column; gap: 8px; margin-top: 12px; margin-bottom: 0;"></div>

  <div class="table-scroll">
      <table mat-table [dataSource]="choirResources" class="mat-elevation-z8" style="width: 100%;">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Resource Name</th>
          <td mat-cell *matCellDef="let resource">
            <a href="#" (click)="onChoirResourceClick($event, resource)">{{ resource.name }}</a>
          </td>
        </ng-container>

        <!-- Resource Type Column (shown on handset via displayedColumns) -->
        <ng-container matColumnDef="resourceType">
          <th mat-header-cell *matHeaderCellDef>Resource Type</th>
          <td mat-cell *matCellDef="let resource">{{ resource.resourceType }}</td>
        </ng-container>

        <!-- Path Column -->
        <ng-container matColumnDef="path">
          <th mat-header-cell *matHeaderCellDef>Resource Path</th>
          <td mat-cell *matCellDef="let resource">{{ resource.path }}</td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>
            <span *ngIf="currentUserIsAdmin">Actions</span>
          </th>
          <td mat-cell *matCellDef="let resource">
            <ng-container *ngIf="currentUserIsAdmin">
              <button mat-button color="warn" (click)="editChoirResource(resource)">Edit</button>
              <button mat-button color="warn" (click)="deleteChoirResource(resource.id)">Delete</button>
            </ng-container>
          </td>
        </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <p *ngIf="choirResources.length === 0">No choir resources available.</p>
  </div>
</div>